import React from 'react';
import { useDispatch } from 'react-redux';
import { SingleDatePicker } from '../../../../../CommonComponents/OPL/dates/SingleDatePicker/SingleDatePicker';
import { dateToISO8601, iso8601ToDate } from '../../../../helpers/dates';
import { today } from '../../../../AccountPerformanceReporting.constants';
import { useInceptionDate } from '../../../../hooks/useInceptionDate';
import { usePositionsDate } from '../../../../hooks/usePositionsDate';
import { setPositionsDate } from '../../../../state/actions';

export const DateSelector = ({ isEmbeddedMobile }) => {
  const inceptionDate = useInceptionDate();

  const positionsDate = usePositionsDate();

  const dispatch = useDispatch();

  return (
    <SingleDatePicker
      date={iso8601ToDate(positionsDate)}
      onChange={date => {
        dispatch(setPositionsDate(dateToISO8601(date)));
      }}
      minDate={inceptionDate ? iso8601ToDate(inceptionDate) : undefined}
      maxDate={iso8601ToDate(today)}
      isWrapperWidth={isEmbeddedMobile}
    />
  );
};
